import { createStore } from '@xstate/store'

type BridgeRouteEvent =
  | AnalyzerSettingsRoute
  | AnalyzeHandsRoute
  | AnalyzeUploadsRoute
  | AnalyzeReportsRoute
  | HandsStats
  | UserAccount
  | UserSubscriptionRoute
  | UserCreditsRoute
  | UserSettingsRoute
  | UserAppearanceRoute
  | SubscriptionOverviewRoute
  | StudySolutionsRoute
  | StudyReportsRoute
  | CoachingRoute
  | StudyPlansRoute
  | DashboardRoute
  | PlayModeRoute
  | PracticeTrainerRoute
  | PracticeRangeBuilderRoute
  | PracticeDrillsRoute
  | PracticeHandsRoute
  | PracticeSessionsRoute
  | PracticeStatsRoute
  | PracticePlayRoute
  | Hands

type AnalyzerSettingsRoute = {
  route: 'analyzerSettings'
}

type Hands = {
  route: 'hands'
}

type HandsStats = {
  route: 'handsStats'
  query: {
    reportName: string
  }
}

type UserAccount = {
  route: 'UserAccount'
}

type AnalyzeHandsRoute = {
  route: 'analyzeHands'
  query?: {
    reportId: string
    played_at?: string[]
    source?: string | null
  }
}

type SubscriptionOverviewRoute = {
  route: 'subscriptionOverview'
  params?: {
    gm_type: string
  }
}

type StudySolutionsRoute = {
  route: 'studySolutions'
}

type StudyReportsRoute = {
  route: 'studyReports'
}

type CoachingRoute = {
  route: 'coaching'
}

type StudyPlansRoute = {
  route: 'studyPlans'
}

type DashboardRoute = {
  route: 'dashboard'
}

type PlayModeRoute = {
  route: 'play'
}

type UserSubscriptionRoute = {
  route: 'userSubscription'
}

type UserCreditsRoute = {
  route: 'userCredits'
}

type UserSettingsRoute = {
  route: 'userSettings'
}

type UserAppearanceRoute = {
  route: 'userAppearance'
}

type AnalyzeUploadsRoute = {
  route: 'analyzeUploads'
}

type AnalyzeReportsRoute = {
  route: 'analyzeReports'
}

type PracticePlayRoute = {
  route: 'practicePlay'
}

type PracticeTrainerRoute = {
  route: 'practiceTrainer'
}

type PracticeRangeBuilderRoute = {
  route: 'practiceRangeBuilder'
}

type PracticeDrillsRoute = {
  route: 'practiceDrills'
}

type PracticeHandsRoute = {
  route: 'practiceHands'
}

type PracticeSessionsRoute = {
  route: 'practiceSessions'
}

type PracticeStatsRoute = {
  route: 'practiceStats'
}

type Context = {
  route: BridgeRouteEvent['route'] | null
  action: RouterBridgeHistoryEvent['action'] | null
}

type RouterBridgeHistoryEvent = {
  action: 'back' | 'forward'
}

const context: Context = {
  route: null,
  action: null,
}

export const routerBridge = createStore({
  context,
  emits: {
    routeChanged: (_payload: BridgeRouteEvent) => {},
    history: (_payload: RouterBridgeHistoryEvent) => {},
  },
  on: {
    changeRoute: (context, event: BridgeRouteEvent, enqueue) => {
      enqueue.emit.routeChanged(event)

      return {
        ...context,
        route: event.route,
      }
    },
    history: (context, event: RouterBridgeHistoryEvent, enqueue) => {
      enqueue.emit.history(event)

      return {
        ...context,
        route: null,
      }
    },
  },
})
